/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Request model for initializing a video upload
 */
export interface InitializeUploadRequest { 
    title: string;
    description: string;
    gender: string;
    category: string;
    competition: string;
    championship: string;
    fileSize: number;
    fileName: string;
}

